/*
 * サブシステム名：OTM受付一覧編集
 * 機能名：受付一覧編集
 */
import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue'

import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin, { ThirdPartyDraggable } from '@fullcalendar/interaction'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import jaLocale from '@fullcalendar/core/locales/ja'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'

import indexeddb from '@/ddv2.library/indexeddb'
import date from '@/ddv2.library/date'

// import { mapGetters } from 'vuex'
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
const DdDateBox = () => import('@/components/DdDateBox')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTimeBox = () => import('@/components/DdTimeBox')

export default {
  name: 'PlanScheduler',
  mixins: [flowMixin],
  components: {
    FullCalendar,
    DdCustomButton,
    DdTransparentButton,
    DdDateBox,
    DdTextBox,
    DdTimeBox
  },
  data: () => ({
    // 検索用
    conditions: {},
    prevStart: null,
    prevEnd: null,

    // FULL-CALENDAR
    rows: [],
    calendarOptions: {
      schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives', // Free Trial ライセンスキー
      locale: jaLocale, // ロケールを日本語に設定
      // contentHeight: 'auto',
      height: 500, // ← 明示的に追加（または contentHeight を削除）
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,dayGridWeek,customThreeDayWeek,timeGridDay,spacer,resourceTimelineMonth,resourceTimelineWeek,resourceTimelineThreeDay,resourceTimelineDay'
      },
      customButtons: {
        spacer: {
          text: '', // 空白
          click: () => {} // なにもしない
        }
      },
      /*
      resourceAreaHeaderContent: '車両', // 表題を変更
      */
      resourceAreaWidth: '345px', // リソース列の幅を指定
      resourceAreaColumns: [
        {
          field: 'jidoshaHyojiNm',
          headerContent: '車両',
          className: 'g-col-sharyo'
        },
        {
          field: 'jininNm1',
          headerContent: '乗務員',
          className: 'g-col-jinin'
        },
        {
          field: 'jininNm2',
          headerContent: '同乗者',
          className: 'g-col-jinin'
        }
      ],
      views: {
        resourceTimelineDay: {
          slotLabelFormat: [
            { hour: '2-digit', minute: '2-digit', meridiem: false, hour12: false } // 下段に時間（例: '6am'）
          ],
          slotDuration: '01:00', // 1時間間隔
          slotLabelInterval: '01:00', // 時間ラベルの間隔を1時間ごとに
          eventContent: function (arg) {
            const { timeFromToText, customer, rootText } = arg.event.extendedProps
            const fullTitle = `${timeFromToText} ${customer} ${rootText}`

            return {
              html: `
                <div class="fc-custom-event" title="${fullTitle}">
                  <div class="fc-custom-title">${customer}</div>
                  <div class="fc-custom-title">${rootText}</div>
                </div>
              `
            }
          }
        },
        resourceTimelineWeek: {
          slotLabelFormat: [
            { weekday: 'short', day: 'numeric' }, // 上段に日付（例: 'Sun 1/19'）
            { hour: '2-digit', minute: '2-digit', meridiem: false, hour12: false } // 下段に時間（例: '6am'）
          ],
          slotDuration: '01:00', // 1時間間隔
          slotLabelInterval: '04:00', // 時間ラベルの間隔を1時間ごとに
          eventContent: function (arg) {
            const { timeFromToText, customer, rootText } = arg.event.extendedProps
            const fullTitle = `${timeFromToText} ${customer} ${rootText}`

            return {
              html: `
                <div class="fc-custom-event" title="${fullTitle}">
                  <div class="fc-custom-title">${customer}</div>
                  <div class="fc-custom-title">${rootText}</div>
                </div>
              `
            }
          }
        },
        resourceTimelineMonth: {
          slotLabelFormat: [
            { weekday: 'short', day: 'numeric' } // 曜日 + 日付を表示
          ],
          slotMinWidth: 140, // ← タイムライン側の1スロットの最小幅を指定（px）
          eventContent: function (arg) {
            const { timeFromToText, customer, rootText } = arg.event.extendedProps
            const fullTitle = `${timeFromToText} ${customer} ${rootText}`

            return {
              html: `
                <div class="fc-custom-event" title="${fullTitle}">
                  <div class="fc-custom-time">${timeFromToText}</div>
                  <div class="fc-custom-title">${customer}</div>
                  <div class="fc-custom-title">${rootText}</div>
                </div>
              `
            }
          }
        },

        // カスタム設定
        resourceTimelineThreeDay: {
          type: 'resourceTimeline',
          duration: { days: 3 },
          slotDuration: '04:00',
          slotLabelFormat: [
            { weekday: 'short', day: 'numeric' },
            { hour: '2-digit', minute: '2-digit', hour12: false }
          ],
          eventContent: function (arg) {
            const { timeFromToText, customer, rootText } = arg.event.extendedProps
            const fullTitle = `${timeFromToText} ${customer} ${rootText}`

            return {
              html: `
                <div class="fc-custom-event" title="${fullTitle}">
                  <div class="fc-custom-time">${timeFromToText}</div>
                  <div class="fc-custom-title">${customer}</div>
                  <div class="fc-custom-title">${rootText}</div>
                </div>
              `
            }
          }
        },
        customThreeDayWeek: {
          type: 'dayGrid',
          duration: { days: 3 } // 3日間表示
        }
      },
      slotLabelFormat: [
        { hour: '2-digit', minute: '2-digit', meridiem: false, hour12: false } // 00:00, 01:00, ...
      ],
      resources: [
        { id: '9021', title: '品川112う2852' },
        { id: '542', title: '品川106か907' },
        { id: '8093', title: '品川106う6562' }
      ],
      eventTimeFormat: { // 時間フォーマットの指定
        hour: 'numeric',
        minute: '2-digit',
        hour12: false, // 24時間形式を指定
        meridiem: false // AM/PM を非表示
      },
      buttonText: {
        customThreeDayWeek: '３日',
        resourceTimelineThreeDay: '３日'
      },
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, resourceTimelinePlugin],
      // initialView: 'dayGridWeek',
      initialView: 'resourceTimelineMonth',
      weekends: false,
      editable: true, // ドラッグ＆ドロップを有効化
      droppable: true, // 外部からのドロップを有効化
      drop: function (info) {
        if (info.draggedEl && info.draggedEl.parentNode) {
          info.draggedEl.parentNode.removeChild(info.draggedEl)
        }
      },

      /**
       * イベント定義
       * @param {} arg
       * @returns
       */
      viewDidMount: function (arg) {
        const calendar = arg.view.calendar

        // resourceTimelineMonth 以外は無視
        if (arg.view.type !== 'resourceTimelineMonth') return

        // 上部の日付ヘッダー（タイムラインのスロット列）を探す
        setTimeout(() => {
          document.querySelectorAll('.fc-timeline-slot').forEach(el => {
            const text = el.textContent
            const match = text.match(/(\d{1,2})日/) // 例: '2日（木）'
            if (match) {
              const day = match[1].padStart(2, '0')
              const today = calendar.getDate()
              const y = today.getFullYear()
              const m = today.getMonth() + 1
              const dateStr = `${y}-${String(m).padStart(2, '0')}-${day}`

              el.addEventListener('dblclick', () => {
                calendar.gotoDate(dateStr)
                calendar.changeView('resourceTimelineDay')
              })
            }
          })
        }, 0) // 少し遅延させてDOMが描画されてから実行
      },
      // データセットイベント
      datesSet: null,
      // ダミー
      events: []
    },
    externalEvents: [],

    // 表示制御用
    showWeekEnd: true,
    dayMaxEventRows: null,

    // イベント管理用
    event: {},
    events: [],
    eventFilter: null,
    showEventDialog: false,

    // 制御用
    modeKengen: 0
  }),
  watch: {
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      sharyoList: 'DDMasters/vwCMstSharyo',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      helpUseFlg: 'users/helpUseFlg'
    })
  },
  created () {
  },
  mounted () {
    console.log('D2PLMD9010 mounted')
    this.initialize()

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    const externalEventContainer = document.getElementById('external-events')
    // ドラッグ可能アイテムの設定（ThirdPartyDraggable）
    // eslint-disable-next-line no-unused-vars
    const _ = new ThirdPartyDraggable(externalEventContainer, {
      itemSelector: '.fc-event'
    })
    /*
    this.$nextTick(() => {
      document.querySelectorAll('#external-events .fc-event').forEach(el => {
        el.setAttribute('draggable', 'true') // 明示的にドラッグ可能に

        el.addEventListener('dragstart', (e) => {
          // カスタムドラッグ画像を設定
          const dragGhost = el.cloneNode(true)
          dragGhost.style.position = 'absolute'
          dragGhost.style.top = '-1000px'
          dragGhost.style.left = '-1000px'
          dragGhost.style.opacity = '0.7'
          document.body.appendChild(dragGhost)
          e.dataTransfer.setDragImage(dragGhost, 10, 10)

          setTimeout(() => {
            document.body.removeChild(dragGhost)
          }, 0)
        })
      })
    })
    */
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      const height = window.innerHeight - 270
      this.$refs.ddCalendar.getApi().setOption('height', height)
    },

    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'vwcmstsharyo'],
        defineHeaderPromise: () => {
          return new Promise((resolve) => {
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            resolve()
          })
        },
        researchPromise: (c) => {
          console.log('OtmDeliveryLedger.researchPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('OtmDeliveryLedger.restoreViewPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('OtmDeliveryLedger.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            self.searchAction()

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },

    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const d = new Date()

      this.prevStart = date.getLastDate(d.getFullYear(), d.getMonth())
      this.prevEnd = date.getFirstDate(d.getFullYear(), d.getMonth() + 2)

      this.conditions = {
        sagyoYoteiYmdFrom: this.prevStart,
        sagyoYoteiYmdTo: this.prevEnd
      }
    },

    onDatesSet (arg) {
      const addDays = (date, days) => {
        const newDate = new Date(date)
        newDate.setDate(newDate.getDate() + days)
        return newDate
      }
      const formatDate = (date) => {
        return date.toLocaleDateString('ja-JP', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        })
      }

      const fromDate = formatDate(addDays(arg.start, -1)) // -2日
      const toDate = formatDate(addDays(arg.end, 0))

      // 前回と同じならスキップ（getTimeで厳密比較）
      if (this.prevStart === fromDate && this.prevEnd === toDate) {
        return
      }

      this.prevStart = fromDate
      this.prevEnd = toDate

      // alert('date click! ' + arg.view.type + ' : ' + fromDate + ' : ' + toDate)
      // console.log('View changed:', arg.view.type)
      // console.log('Start:', fromDate)
      // console.log('End:', toDate)
      this.conditions = {
        sagyoYoteiYmdFrom: fromDate,
        sagyoYoteiYmdTo: toDate
      }
      this.searchAction()
    },

    searchAction: function (noMessage) {
      /*
       * ToDo:日付変更のタイミングでFromToを取得するようにする
       */
      this.rows = []
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2plmd1000/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          const resultData = data.payload
          // 検索結果保持用にセット
          resultData.map((elem, index) => {
            // ここから表示用編集
            elem.sagyoYoteiYmd = filter.dateFormatter(elem.sagyoYoteiYmd)
            elem.hatsuchiYmd = ![undefined, null, ''].includes(elem.hatsuchiYmd) ? filter.dateFormatter(elem.hatsuchiYmd) : ''
            elem.hatsuchiHms = ![undefined, null, ''].includes(elem.hatsuchiHms) ? (elem.hatsuchiHms).slice(0, 5) : ''
            elem.chakuchiYmd = ![undefined, null, ''].includes(elem.chakuchiYmd) ? filter.dateFormatter(elem.chakuchiYmd) : ''
            elem.chakuchiHms = ![undefined, null, ''].includes(elem.chakuchiHms) ? (elem.chakuchiHms).slice(0, 5) : ''
            elem.seikyuYoteiYmd = ![undefined, null, ''].includes(elem.seikyuYoteiYmd) ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
            elem.shiharaiYoteiYmd = ![undefined, null, ''].includes(elem.shiharaiYoteiYmd) ? filter.dateFormatter(elem.shiharaiYoteiYmd) : ''

            return elem
          })
          self.rows = resultData

          self.initSettings()
        },
        isNoMessageModeMethod: function () {
          return noMessage
        },
        getSavedInputMethod: function () {
          return {}
        },
        failureValidateMethod: function () {
          self.torikomiConditonsRequired = true
          self.tableRowRequired = true
        }
      }
      this.search(opt)
    },
    // 検索前チェック
    searchValidate: function () {
      return true
    },

    initSettings: function () {
      this.dayMaxEventRows = null

      const self = this

      this.events = this.rows.map((elem) => {
        const startYmd = ![undefined, null, ''].includes(elem.hatsuchiYmd) ? filter.dateInputFormatter(elem.hatsuchiYmd) : filter.dateInputFormatter(elem.sagyoYoteiYmd)
        const startHms = ![undefined, null, ''].includes(elem.hatsuchiHms) ? `${elem.hatsuchiHms}` : ''
        const endYmd = ![undefined, null, ''].includes(elem.chakuchiYmd) ? filter.dateInputFormatter(elem.chakuchiYmd) : ''
        const endHms = ![undefined, null, ''].includes(elem.chakuchiHms) ? `${elem.chakuchiHms}` : ''

        const m = indexeddb.getRecord(self.torihikisakiList, elem.tokuisakiId)
        const color = m ? m.color ?? '#c8f7ff' : '#c8f7ff'

        return {
          title: `${elem.tokuisakiNm} ${elem.hatsuchiNm ?? ''}>${elem.chakuchiNm ?? ''} ${elem.hinmeiNm ?? ''}`,
          start: startYmd + 'T' + startHms,
          end: endYmd ? endYmd + 'T' + endHms : undefined,
          resourceId: elem.sharyoId,
          className: 'custom-set',
          extendedProps: {
            timeFromToText: `${startYmd === endYmd ? '' : startYmd.replaceAll('-', '/') + ' '}${startHms} - ${startYmd === endYmd ? '' : endYmd.replaceAll('-', '/') + ' '}${endHms}`,
            customer: `${elem.tokuisakiNm}`,
            rootText: `${elem.hatsuchiNm ?? ''} ⇒ ${elem.chakuchiNm ?? ''}`
          },
          backgroundColor: color
        }
      })

      // 車両リスト
      const wSharyoList = this.sharyoList
        .slice()
        .sort((a, b) => {
          if (a.hyojiOrder - b.hyojiOrder !== 0) return a.hyojiOrder - b.hyojiOrder
          if (a.sharyoCd > b.sharyoCd) return 1
          if (a.sharyoCd === b.sharyoCd) return 0
          return -1
        })
        .flatMap(sharyo => {
          // 該当する rows をすべて取得
          const matchedRows = this.rows.filter(row => row.sharyoId === sharyo.id)

          // rows がなければ1行だけ空で返す（車両だけ表示したい場合）
          if (matchedRows.length === 0) {
            return [{
              id: sharyo.id,
              jidoshaHyojiNm: sharyo.jidoshaHyojiNm,
              jininNm1: '',
              jininNm2: ''
            }]
          }

          // rows から1行ずつ展開
          return matchedRows.map(row => ({
            id: sharyo.id,
            jidoshaHyojiNm: sharyo.jidoshaHyojiNm,
            jininNm1: row.jininNm1 ?? '',
            jininNm2: row.jininNm2 ?? ''
          }))
        })

      this.calendarOptions = {
        ...this.calendarOptions,
        dayCellDidMount: this.addButtonToCell,
        resources: wSharyoList,
        weekends: this.showWeekEnd,
        dayMaxEvents: this.dayMaxEventRows, // 1日あたり最大2行のイベントを表示
        eventDrop: this.handleEventDrop, // イベントをドロップしたときの処理
        eventClick: this.handleEventClick, // イベントをクリックしたときの処理
        dateClick: this.handleDateClick,
        datesSet: this.onDatesSet,
        events: this.events
      }
    },

    // FOR FULL-CALENDAR
    addButtonToCell: function (arg) {
      if (arg.view.type === 'dayGridMonth' || arg.view.type === 'dayGridWeek') {
        const button = document.createElement('button')
        button.innerHTML = '<span class="material-icons event-add-icon">add</span>'
        // button.setAttribute('data-date', arg.date.toISOString().slice(0, 10))
        // button.style.position = 'absolute'
        // button.style.bottom = '5px'
        // button.style.right = '5px'
        // button.style.padding = '2px 5px'
        // button.style.fontSize = '0.8em'
        // button.style.cursor = 'pointer'
        button.classList.add('event-add-button')

        button.addEventListener('click', (event) => {
          // const date = event.target.getAttribute('data-date')
          const date = dayjs(arg.date).format('YYYY-MM-DD')
          this.showEventDialog = true
          this.createEvent(date)
        })

        arg.el.style.position = 'relative'
        arg.el.appendChild(button)
      }
    },
    addEvent: function (date) {
      alert(`Add event for ${date}`)
    },

    /**
     * 上部画面制御用
     */
    updateFilterdEventRows: function (val) {
      this.eventFilter = val
      this.calendarOptions = {
        ...this.calendarOptions,
        events: this.filteredEvents()
      }
    },
    updateShowWeekend: function (val) {
      this.showWeekEnd = val
      this.calendarOptions = {
        ...this.calendarOptions,
        weekends: val
      }
    },
    updateDayMaxEventRows: function (val) {
      this.dayMaxEventRows = val
      this.calendarOptions = {
        ...this.calendarOptions,
        dayMaxEvents: val
      }
    },

    getEventColor: function (eventType) {
      const colorMap = {
        important: 'red',
        meeting: 'aqua',
        private: 'lightgreen'
      }
      return colorMap[eventType] || '#3788d8'
    },

    /**
     * ドラッグ＆ドロップ
     */
    handleEventDrop: function (info) {
      const movedEvent = info.event
      const newStart = dayjs(movedEvent.start)
      const newEnd = movedEvent.end ? dayjs(movedEvent.end) : null

      const startYmd = newStart.format('YYYY-MM-DD')
      const startHms = newStart.format('HH:mm')

      const endYmd = newEnd ? newEnd.format('YYYY-MM-DD') : ''
      const endHms = newEnd ? newEnd.format('HH:mm') : ''

      console.log('開始日時:', startYmd, startHms, '/ 終了日時:', endYmd, endHms)

      const timeFromToText = `${startYmd === endYmd ? '' : startYmd.replaceAll('-', '/') + ' '}${startHms} - ${startYmd === endYmd ? '' : endYmd.replaceAll('-', '/') + ' '}${endHms}`

      // extendedProps を更新（ここがツールチップに使われる）
      movedEvent.setExtendedProp('timeFromToText', timeFromToText)
      // もし title を tooltip に使っているなら title も更新
      // movedEvent.setProp('title', `${timeFromToText}\n${movedEvent.extendedProps.customer} ${movedEvent.extendedProps.rootText}`)

      // 例: イベントIDと一致する row を更新
      const eventId = movedEvent.id
      const matchedRow = this.rows.find(row => row.id === eventId)
      if (matchedRow) {
        matchedRow.hatsuchiYmd = startYmd
        matchedRow.hatsuchiHms = startHms
        matchedRow.chakuchiYmd = endYmd
        matchedRow.chakuchiHms = endHms
      }
    },
    /**
     * イベントクリック
     */
    handleEventClick: function (arg) {
      if (this.clickTimer) {
        // ダブルクリックと判定（300ms以内）
        clearTimeout(this.clickTimer)
        this.clickTimer = null
        this.showEventDetail(arg.event) // ← ダブルクリック時の処理
      } else {
        // 1回目のクリック → タイマー開始
        this.clickTimer = setTimeout(() => {
          this.clickTimer = null
          console.log('シングルクリック処理:', arg.event.title)
          // ここにシングルクリック時の処理を書く
          arg.jsEvent.preventDefault() // デフォルトのリンク動作を無効化
          if (arg.event.url) {
            setTimeout(() => {
              window.open(arg.event.url, '_blank') // URLを別タブで開く
            })
          }
        }, 300) // ← 300ms以内にもう1回クリックがあればダブルクリックとみなす
      }
    },
    showEventDetail (event) {
      alert('go Event!!')
    },

    /**
     * 日付欄クリック（※”日”表示字のみ）
     */
    handleDateClick: function (arg) {
      if (arg.view.type === 'timeGridDay') {
        // alert('date click! ' + arg.dateStr)
        this.showEventDialog = true
        this.createEvent(arg.dateStr)
      }
    },
    createEvent: function (val) {
      // 日時
      var paramDate = new Date(val)
      var currentTime = new Date()

      // 日付をYYYY-MM-DD形式に変換
      var formattedDate = val.slice(0, 10).replaceAll('-', '/') // YYYY-MM-DD の形式
      var formatteStartTime = null
      var formatteEndTime = null

      if (val.includes('T')) {
        // 時間情報が含まれている場合
        formatteStartTime = paramDate.toTimeString().slice(0, 5) // HH:mm の形式
        // 一時間後の取得
        paramDate.setHours(paramDate.getHours() + 1)
        formatteEndTime = paramDate.toTimeString().slice(0, 5) // HH:mm の形式
      } else {
        formatteStartTime = this.formatDateToHM(currentTime, 0)
        formatteEndTime = this.formatDateToHM(currentTime, 1)
      }
      this.event.startDate = formattedDate
      this.event.endDate = formattedDate
      this.event.startTime = formatteStartTime
      this.event.endTime = formatteEndTime
    },

    onAddEvent: function () {
      const startDT = this.event.startDate.replaceAll('/', '-') + (this.event.etartTime === '' ? '' : ('T' + this.event.startTime + ':00'))
      const endDT = this.event.endDate.replaceAll('/', '-') + (this.event.endTime === '' ? '' : ('T' + this.event.endTime + ':00'))
      // イベント追加
      this.events.push({
        start: startDT,
        end: endDT,
        title: this.event.eventTitle,
        allDay: this.event.allday
      })
      this.calendarOptions = {
        ...this.calendarOptions,
        events: this.filteredEvents()
      }
      this.showEventDialog = false
    },

    filteredEvents: function () {
      const self = this
      const w = this.events.filter((t) => {
        return self.eventFilter === null || t.title.indexOf(self.eventFilter) >= 0
      })
      return w
    },
    formatDateToYMD (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    formatDateToHM (currentTime, factor) {
      const hours = String(currentTime.getHours() + factor).padStart(2, '0')
      const minutes = String(currentTime.getMinutes()).padStart(2, '0')
      return `${hours}:${minutes}`
    },
    onDummyFunction: function () {
    }
  }
}
